import React from 'react'
import {
  IInnovationTimeline as IContentfulInnovationTimeline,
  IInnovationTimelineCard as IContentfulInnovationTimelineCard,
} from 'marketing-site/@types/generated/contentful'
import {
  ITimeline,
  ITimelineCard,
  InnovationTimeline,
} from 'marketing-site/src/components/bespoke/innovation-campaign/timeline'
import { transformCTALink } from 'marketing-site/src/transformers/elements/ContentfulCTALink'
import { transformImage } from 'marketing-site/src/transformers/elements/ContentfulImage'

export function ContentfulInnovationTimeline(data: IContentfulInnovationTimeline) {
  return <InnovationTimeline {...transformInnovationTimeline(data)} />
}

export function transformInnovationTimeline({ fields }: IContentfulInnovationTimeline) {
  const transformedData: Omit<ITimeline, 'isMobile'> = {
    ...fields,
    cards: fields.timelineCards.map(transformTimelineCard),
    image: fields.eyebrowImage && transformImage(fields.eyebrowImage),
  }
  return transformedData
}

function transformTimelineCard({ fields }: IContentfulInnovationTimelineCard): ITimelineCard {
  return {
    ...fields,
    cta: transformCTALink(fields.ctaLink),
  }
}
